export default function needRefresh(state = false, action) {
  switch (action.type) {
    case 'NEED_REFRESH':
      return { refresh: action.data };
    default:
      return state;
  }
}
